import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Chip } from '@mui/material';

interface QuickOpenDialogProps {
  open: boolean;
  value: string;
  loading: boolean;
  error: string;
  recentIds: string[];
  onChange: (value: string) => void;
  onClose: () => void;
  onSubmit: () => void;
  onPickRecent: (id: string) => void;
}

export const QuickOpenDialog: React.FC<QuickOpenDialogProps> = ({
  open,
  value,
  loading,
  error,
  recentIds,
  onChange,
  onClose,
  onSubmit,
  onPickRecent,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="quick-open-dialog"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle className="quick-open-title">Quick Open Test Result</DialogTitle>
      <DialogContent className="quick-open-content">
        <TextField
          autoFocus
          fullWidth
          label="Test Result ID"
          placeholder="Enter result ID and press Enter"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !loading) {
              event.preventDefault();
              onSubmit();
            }
          }}
          size="small"
          className="quick-open-input"
        />
        {error && (
          <div className="quick-open-empty">
            <div className="quick-open-empty-title">Check ID</div>
            <div className="quick-open-empty-subtitle">No result found for that ID.</div>
          </div>
        )}
        {recentIds.length > 0 && (
          <div className="quick-open-recent">
            <div className="quick-open-recent-title">Recent IDs</div>
            <div className="quick-open-recent-chips">
              {recentIds.map((id) => (
                <Chip
                  key={id}
                  label={id}
                  onClick={() => onPickRecent(id)}
                  className="quick-open-chip"
                  variant="outlined"
                  size="small"
                />
              ))}
            </div>
          </div>
        )}
      </DialogContent>
      <DialogActions className="quick-open-actions">
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={loading}
        >
          Open
        </Button>
      </DialogActions>
    </Dialog>
  );
};
